// extracted by mini-css-extract-plugin
export default {"menu":"menu-MRKZb","divider":"divider-_qD3v"};